<script>
  import { inertia, page, router } from '@inertiajs/svelte';
  import Icon from '@iconify/svelte';
  import Flash from './Flash.svelte';

  let { title = '', children } = $props();

  let account = $derived(page.props.auth?.account);
  let workspace = $derived(page.props.auth?.workspace);
  let current = $derived(page.url);

  const nav = [
    { href: '/', label: 'Dashboard', icon: 'mdi:view-dashboard-outline' },
    { href: '/calendars', label: 'Calendars', icon: 'mdi:calendar-multiple' },
    { href: '/posts', label: 'Posts', icon: 'mdi:pencil-outline' },
    { href: '/bins', label: 'Bins', icon: 'mdi:tray-full' },
    { href: '/slots', label: 'Slots', icon: 'mdi:calendar-clock-outline' },
    { href: '/social_accounts', label: 'Accounts', icon: 'mdi:account-multiple-outline' },
  ];

  function isActive(href) {
    return href === '/' ? current === '/' : current.startsWith(href);
  }

  function logout() {
    router.post('/auth/logout');
  }
</script>

<svelte:head><title>{title ? `${title} · neosocialmix` : 'neosocialmix'}</title></svelte:head>

<div class="min-h-screen">
  <header class="bg-secondary-50/80 border-b-2 border-primary-900/70">
    <div class="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
      <div class="flex items-center gap-8">
        <a use:inertia href="/" class="flex items-center gap-2 text-primary-900 font-display text-xl tracking-tight">
          <Icon icon="mdi:stamper" class="text-primary-700" />
          neosocialmix
        </a>
        <nav class="flex items-center gap-1">
          {#each nav as item}
            <a
              use:inertia
              href={item.href}
              class="flex items-center gap-2 px-3 py-2 text-sm font-medium transition-colors
                {isActive(item.href) ? 'ink-nav-active text-primary-900' : 'text-secondary-600 hover:text-primary-900'}"
            >
              <Icon icon={item.icon} />
              {item.label}
            </a>
          {/each}
        </nav>
      </div>

      {#if account}
        <div class="flex items-center gap-3 text-sm">
          {#if account.is_admin}
            <a use:inertia href="/admin" class="text-secondary-500 hover:text-amber-600 flex items-center gap-1">
              <Icon icon="mdi:shield-crown-outline" /> Admin
            </a>
          {/if}
          <span class="text-secondary-500 hidden sm:inline">{workspace?.name || account.email}</span>
          <button onclick={logout} aria-label="Sign out" class="text-secondary-500 hover:text-red-600 flex items-center gap-1">
            <Icon icon="mdi:logout" /> Sign out
          </button>
        </div>
      {/if}
    </div>
  </header>

  <main class="max-w-5xl mx-auto px-6 py-8">
    {#if title}
      <h1 class="text-hierarchy-1 ink-underline mb-6">{title}</h1>
    {/if}
    <Flash />
    {@render children?.()}
  </main>
</div>
